import { installationDayTitle } from "./installationDayTitle";
import { Check } from "lucide-react";
import { useGetIdentity, type Identifier } from "ra-core";
import type { Task } from "../types";
import { calendarTaskStyle } from "../deals/projectColors";
import { installationRangeLabel } from "./installation";
import { taskPeriodLabel, taskDayLabel } from "./taskPeriod";
import { taskCompleted } from "./calendarModel";
import { TaskQuickStatus } from "./TaskQuickStatus";
import "./calendar.css";

export function CalendarEvent({
  task,
  color,
  projectName,
  onOpen,
  installation = false,
  personal = false,
  owner,
  compact = false,
  day,
  quickStatus = !compact,
}: {
  task: Task;
  color?: string;
  projectName?: string;
  onOpen: (id: Identifier) => void;
  installation?: boolean;
  personal?: boolean;
  owner?: string;
  compact?: boolean;
  day?: Date;
  quickStatus?: boolean;
}) {
  const { identity } = useGetIdentity();
  const canChangeStatus =
    !!identity &&
    (identity.administrator ||
      String(task.sales_id) === String(identity.id) ||
      String(task.created_by_sales_id) === String(identity.id));
  return (
    <article
      data-calendar-type={installation ? "installation" : "task"}
      data-project-id={task.deal_id}
      className={`crm-agenda-event ${compact ? "crm-event-compact" : ""}`}
      style={calendarTaskStyle(task, color)}
    >
      <button
        type="button"
        className="min-w-0 flex-1 text-left"
        onClick={() => onOpen(task.id)}
      >
        {!installation && (
          <span className="mb-1 block text-xs font-semibold tabular-nums">
            {taskPeriodLabel(task)}
          </span>
        )}
        {day && taskDayLabel(task, day) && (
          <span className="mb-1 block text-xs font-semibold">
            {taskDayLabel(task, day)}
          </span>
        )}
        <span className="block text-sm font-medium">
          {installation ? installationDayTitle(task, day) : task.text}
        </span>
        {taskCompleted(task) && (
          <span className="crm-personal-badge crm-completed-badge">
            <Check aria-hidden="true" /> Выполнено
          </span>
        )}
        {personal ? (
          <span className="crm-personal-badge">Личная</span>
        ) : !installation && owner ? (
          <span className="mt-1 block text-xs text-muted-foreground">
            {owner}
          </span>
        ) : null}
        <span className="mt-1 block text-xs text-muted-foreground">
          {installation
            ? `${installationRangeLabel(task)} · включительно`
            : projectName || (task.team_task ? "Для всей команды" : "")}
        </span>
      </button>
      {canChangeStatus && quickStatus ? (
        <TaskQuickStatus task={task} />
      ) : (
        <span className="ml-auto text-xs text-muted-foreground">
          {taskCompleted(task)
            ? "Выполнена"
            : task.status === "in_progress"
              ? "В работе"
              : "Новая"}
        </span>
      )}
    </article>
  );
}
